import { render, staticRenderFns } from "./Listtt.vue?vue&type=template&id=0a15014a&scoped=true&"
import script from "./Listtt.vue?vue&type=script&lang=js&"
export * from "./Listtt.vue?vue&type=script&lang=js&"
import style0 from "./Listtt.vue?vue&type=style&index=0&id=0a15014a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a15014a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VDivider,VProgressLinear,VSubheader,VTextField})
